import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { useTranslation } from 'react-i18next';
import { clinicViewDataSource } from 'infrastructure/data-sources/clinics-view';

import s from './styles.module.scss';

import type { IClinicViewItem } from 'infrastructure/data-sources/clinics-view';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<string, IClinicViewItem>[];

interface IClinicViewSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClinicViewSelectBox: React.FC<IClinicViewSelectBoxProps> = (props) => {
  const dataSource = useMemo(() => clinicViewDataSource(), []);
  const { t } = useTranslation();

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
      })),
    [dataSource],
  );

  return (
    <label className={s.wrapper}>
      {t('labels.view')}:
      <BaseSelectBox options={options} {...props} />
    </label>
  );
};

export default ClinicViewSelectBox;
